import type { IndustryConf, FeijiteConf, AreaItemVO } from "@/api"
import { getIndustryCategory } from "@/util/commonUtils"
import { useSetState } from "ahooks"
import { createModel } from "hox"
import { useCallback } from "react"

interface IUseConfigState {
  configs: AreaItemVO[]
  currentConfig?: IndustryConf
  feijiteConfig?: FeijiteConf
  // 品牌类型
  industryCategoryType?: string
  industryCategory: string
  // 是否有chatgpt功能
  gptAuth: boolean
}
function useConfig() {
  const [state, set] = useSetState<IUseConfigState>({
    configs: [],
    industryCategory: "门店",
    gptAuth: false,
  })

  const setConfigs = useCallback(
    (value: AreaItemVO[]) => {
      set({
        configs: value,
      })
    },
    [set],
  )

  const setCurrentConfig = useCallback(
    (value: IndustryConf) => {
      set({
        currentConfig: value,
        industryCategoryType: value?.industryCategory,
        industryCategory: getIndustryCategory(value?.industryCategory),
        gptAuth: typeof value?.gptAuth === "boolean" ? value.gptAuth : false,
      })
    },
    [set],
  )

  const setFeijiteConfig = useCallback(
    (value: FeijiteConf) => {
      set({
        feijiteConfig: value,
      })
    },
    [set],
  )

  return {
    ...state,
    setConfigs,
    setCurrentConfig,
    setFeijiteConfig,
  }
}

export default createModel(useConfig)
